import { render } from "./add-notification-opt-in.vue?vue&type=template&id=9074e64c&scoped=true"
import script from "./add-notification-opt-in.vue?vue&type=script&lang=js"
export * from "./add-notification-opt-in.vue?vue&type=script&lang=js"

import "./add-notification-opt-in.vue?vue&type=style&index=0&id=9074e64c&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9074e64c"]])

export default __exports__